module.exports = __webpack_public_path__ + "static/media/real-face.bdb1375e.png";